import _default from './Modal';
export { _default as default };